import { CircleCheckFilled } from 'baseui/icon'
import useFidelityMaximizerSidebar from '@/containers/SubscriptionFormPageNew/Components/FidelityMaximizer/useFidelityMaximizerSidebar'
import { MailIcon, ChartIcon, PersonIcon, PhoneIcon } from '@/containers/SubscriptionFormPageNew/Components/FidelityMaximizer/icons'
import {
  StyledContainer,
  StyledTopContainer,
  StyledHeader,
  StyledTitle,
  StyledIndicator,
  StyledCurrentValue,
  StyledSubtitle,
  StyledProgressBarContainer,
  StyledProgressTrack,
  StyledProgressMask,
  StyledItemsContainer,
  StyledItemRow,
  StyledItemLeft,
  StyledItemLabel,
  StyledDoneIcon,
  StyledPendingIcon,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/FidelityMaximizer/styled-components'

const ITEM_ICONS = {
  nlbp_classic: MailIcon,
  nlbp_personalized: ChartIcon,
  myselectra: PersonIcon,
  app_downloaded: PhoneIcon,
}

const FidelityMaximizerSidebar = () => {
  const { hidden, title, subtitle, items, currentValue, maxValue, isMastered, percentDone } =
    useFidelityMaximizerSidebar()

  if (hidden) {
    return null
  }

  return (
    <StyledContainer $mastered={isMastered}>
      <StyledTopContainer>
        <StyledHeader>
          <StyledTitle>{title}</StyledTitle>
          <StyledIndicator>
            <StyledCurrentValue $reachedMax={isMastered}>{currentValue}</StyledCurrentValue>/{maxValue}
          </StyledIndicator>
        </StyledHeader>
        <StyledSubtitle hidden={!subtitle}>{subtitle}</StyledSubtitle>
        <StyledProgressBarContainer>
          <StyledProgressTrack $mastered={isMastered}>
            <StyledProgressMask $percentDone={percentDone} />
          </StyledProgressTrack>
        </StyledProgressBarContainer>
      </StyledTopContainer>
      <StyledItemsContainer>
        {items.map(item => {
          const PendingIcon = ITEM_ICONS[item.key]
          return (
            <StyledItemRow key={item.key} $done={item.done}>
              <StyledItemLeft>
                {item.done ? (
                  <StyledDoneIcon>
                    <CircleCheckFilled size={20} />
                  </StyledDoneIcon>
                ) : (
                  <StyledPendingIcon>
                    <PendingIcon size={20} />
                  </StyledPendingIcon>
                )}
                <StyledItemLabel $done={item.done}>{item.label}</StyledItemLabel>
              </StyledItemLeft>
            </StyledItemRow>
          )
        })}
      </StyledItemsContainer>
    </StyledContainer>
  )
}

export default FidelityMaximizerSidebar
